import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowDate } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type CreditPurchaseViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  tenantValue: { displayId: string; id: string } | null;
  quantityValue?: { displayId: string; id: string } | null;
  quantity: number;
  purchaseDateValue?: { displayId: string; id: string } | null;
  purchaseDate: string | null;
  expirationDateValue?: { displayId: string; id: string } | null;
  expirationDate: string | null;
  unitPriceValue?: { displayId: string; id: string } | null;
  unitPrice: number | undefined;
  notesValue?: { displayId: string; id: string } | null;
  notes: string;
};

export const CreditPurchaseViewForm: React.FC<CreditPurchaseViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      tenantValue,
      quantity = 0,
      purchaseDate = null,
      expirationDate = null,
      unitPrice = 0,
      notes = "",
    }) => {
      const rootStore = useRootStore();
      const { authStore, langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupCreditPurchaseLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                {["SysAdmin"].some((role) => authStore.hasRole(role)) && (
                  <ShowReference
                    label={langStore.CreditPurchaseTenantLabel}
                    selectedValue={langStore.displayIdByLang(
                      tenantValue?.displayId
                    )}
                  />
                )}
                <ShowNumber
                  value={quantity}
                  label={langStore.CreditPurchaseQuantityLabel}
                />
                <ShowDate
                  value={purchaseDate}
                  label={langStore.CreditPurchasePurchaseDateLabel}
                  locale={langStore.timeFormat}
                />
                <ShowDate
                  value={expirationDate}
                  label={langStore.CreditPurchaseExpirationDateLabel}
                  locale={langStore.timeFormat}
                />
                <ShowNumber
                  value={unitPrice}
                  label={langStore.CreditPurchaseUnitPriceLabel}
                  decimalScale={2}
                />
                <ShowMultiLine
                  value={notes}
                  label={langStore.CreditPurchaseNotesLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
